import React from 'react';
import friendlyError from '../../utils/friendlyError';
import { Link } from 'react-router-dom';
import { FaSyncAlt, FaUserSecret } from 'react-icons/fa';
import { TechSection, TechButtonGhost, TechChip } from '../../styles/techComponents';
import { STATUS_META, TagsGrid, ProfileCard, ProfileHeader, StatusDot, ProfileActions } from './CreadorPerfilesStyles';
import { verifyProfileCredentials, getProfileStatus } from '../../services/digitalProfilesService';

const TarjetaPerfil = ({ savedProfile, platformMeta, setSavedProfile, setFeedback }) => {
  const s = savedProfile?.status ? STATUS_META[savedProfile.status] : null;
  if (!savedProfile) return null;
  return (
    <TechSection title="Perfil Guardado" style={{ marginTop: '1.25rem' }}>
      <ProfileCard $accentColor={s?.color || platformMeta.color} $borderColor={s?.color}>
        <ProfileHeader $iconColor={platformMeta.color}>
          <span className="icon"><platformMeta.Icon /></span>
          <div className="info">
            <h4>@{savedProfile.username}{s && <span style={{ marginLeft: '0.6rem', display: 'inline-flex', alignItems: 'center', gap: '0.3rem', fontSize: '0.72rem', fontWeight: 400 }}><StatusDot $color={s.color} />{s.label}</span>}</h4>
            <div className="sub">{platformMeta.label} - ID: {savedProfile.id}{savedProfile.has_password && ' - pass OK'}{savedProfile.has_cookies && ' - cookies OK'}</div>
          </div>
        </ProfileHeader>
        {savedProfile.prompt_personalidad && <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', lineHeight: 1.5 }}><strong style={{ color: 'var(--text-disabled)', fontSize: '0.65rem', textTransform: 'uppercase', letterSpacing: '0.1em' }}>Prompt:</strong> {savedProfile.prompt_personalidad.slice(0, 200)}{savedProfile.prompt_personalidad.length > 200 ? '...' : ''}</div>}
        {savedProfile.intereses?.length > 0 && <TagsGrid>{savedProfile.intereses.map((tag) => <TechChip key={tag} tone="mute">{tag}</TechChip>)}</TagsGrid>}
        <ProfileActions>
          <TechButtonGhost type="button" onClick={async () => {
            try { await verifyProfileCredentials(savedProfile.id); setFeedback({ type: 'success', message: 'Verificacion iniciada.' }); setTimeout(async () => { try { const r = await getProfileStatus(savedProfile.id); if (r.account) setSavedProfile(r.account); } catch {} }, 8000); } catch (err) { setFeedback({ type: 'error', message: friendlyError(err) }); }
          }}><FaSyncAlt /> Re-verificar</TechButtonGhost>
          <TechButtonGhost as={Link} to="/perfiles-digitales"><FaUserSecret /> Ver en Perfiles Digitales</TechButtonGhost>
        </ProfileActions>
      </ProfileCard>
    </TechSection>
  );
};

export default TarjetaPerfil;
